// #region imports

// --- Angular
import { Pipe, PipeTransform } from '@angular/core';

// #endregion

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {

  transform(value: string, args?: any): string {
    const parts = value.split(' ');
    for (let i = 0; i < parts.length; i++) {
      parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
    }
    return parts.join(' ');
  }
}
